import styled from 'styled-components';

export const ListWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 0 !important;

  div {
    margin-bottom: 0 !important;
    margin-left: 0 !important;
  }

  > div > div {
    width: 100%;

    &:empty {
      margin-top: 18px;
      margin-bottom: 26px !important;

      &:last-of-type {
        display: none;
      }
    }
  }
`;
